import type {ReactNode} from 'react';
import {ScreenBreakpoints} from '@Libraries/responsiveness-library';

export const EMAIL_MAKER_SHEET_MOBILE_WIDTH_THRESHOLD = Number(ScreenBreakpoints.LARGE) + 1;

export interface EmailMakerBottomSheetProps {
  modalId: string;
  panelId: string;
  modalMaxHeight?: string;
  /** Top drag-bar; default true. Set false when the sheet's own header sits at the very top — the drag area overlays the first 60px and would block its controls. */
  showDragHandle?: boolean;
  children: ReactNode;
}
